import { render, staticRenderFns } from "./LessonSlideChatViewerComponent.vue?vue&type=template&id=878dd608&scoped=true&"
import script from "./LessonSlideChatViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSlideChatViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSlideChatViewerComponent.vue?vue&type=style&index=0&id=878dd608&prod&lang=css&"
import style1 from "./LessonSlideChatViewerComponent.vue?vue&type=style&index=1&id=878dd608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878dd608",
  null
  
)

export default component.exports